
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/ForgotPasswordPage/ForgotPasswordPage",
      function () {
        return require("private-next-pages/authentication/ForgotPasswordPage/ForgotPasswordPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication/ForgotPasswordPage/ForgotPasswordPage"])
      });
    }
  